import { z } from 'zod';
import { InteractionScope } from './oauth.js';

/**
 * «Мои ИИ-клиенты» (005, T058, T059; specs/005-rules-mcp/contracts/http-api.md). Одна схема для адресов
 * `GET /api/me/agents` и `DELETE /api/me/agents/:grantId` и страницы. Ответ — объект: в 006 рядом встанут компьютеры.
 */

export const MY_AGENT_STATES = ['active', 'revoked', 'expired'] as const;

export const MyAgent = z.object({
  /** Отпечаток гранта (`grant_id_hash`) — адрес отзыва; сам идентификатор гранта наружу не идёт. */
  grantId: z.string(),
  /** Клиент агента: адрес документа клиента (CIMD), название из белого списка, хост документа. */
  client: z.object({ id: z.string(), name: z.string(), host: z.string() }),
  /** Права подключения, тексты — простыми словами, как на странице согласия. */
  scopes: z.array(InteractionScope),
  connectedAt: z.string(),
  lastUsedAt: z.string().nullable(),
  state: z.enum(MY_AGENT_STATES),
});
export type MyAgent = z.infer<typeof MyAgent>;

/** Ответ `GET /api/me/agents`. `DELETE` — 204; чужое или уже отозванное подключение — 404. */
export const MyAgentsResponse = z.object({ agents: z.array(MyAgent) });
export type MyAgentsResponse = z.infer<typeof MyAgentsResponse>;
